import type {PropsWithChildren} from 'react'

export function DiffCodeAlert({children}: PropsWithChildren) {
  return (
    <span className="position-absolute" style={{left: '-1px', zIndex: '1'}}>
      {children}
    </span>
  )
}
